/**
 * Redirect Configuration
 *
 * Manages allowed origins and default redirect URLs
 */

/**
 * Configuration for allowed redirect origins
 * Reads from environment variable REACT_APP_ALLOWED_ORIGINS
 *
 * Environment variable format: comma-separated list of origins
 * Example: "http://localhost:3000,http://localhost:3001,http://34.143.132.10:3000"
 *
 * REQUIRED: REACT_APP_ALLOWED_ORIGINS must be set in .env file
 */
const getDefaultAllowedOrigins = () => {
  // Check if environment variable is set
  if (process.env.REACT_APP_ALLOWED_ORIGINS) {
    const envOrigins = process.env.REACT_APP_ALLOWED_ORIGINS.split(",")
      .map((origin) => origin.trim())
      .filter((origin) => origin.length > 0);

    return envOrigins;
  }

  // No default origins - environment variable must be configured
  console.error(
    "REACT_APP_ALLOWED_ORIGINS is not configured. Add it to your .env file, e.g.: REACT_APP_ALLOWED_ORIGINS=http://localhost:3000,http://localhost:3001",
  );
  return [];
};

export const ALLOWED_ORIGINS = getDefaultAllowedOrigins();

/**
 * Default fallback URLs based on authentication state
 */
export const DEFAULT_REDIRECTS = {
  authenticated: "/dashboard", // Where to go after login
  unauthenticated: "/", // Where to go if redirect fails
};

/**
 * Configuration getter for allowed origins (for debugging)
 */
export const getRedirectConfig = () => ({
  allowedOrigins: ALLOWED_ORIGINS,
  defaultRedirects: DEFAULT_REDIRECTS,
  currentOrigin: window.location.origin,
});
